import React from "react";
import { connect } from "react-redux";
import * as actions from "../../../store/actions";

import "./index.css";
import { getDashboardPath } from "../../../constants";

import RadioButton from "../../../components/formElements/radio-button/RadioButton";
import Button from "../../../components/formElements/button/Button";

import useGeoLocation from "../../../utils/useGeoLocation";
import Modals from "../../../components/uiElements/popupModal/modal";

const ChangeLocation = ({
  address,
  myLocation,
  getCurrentDoctorDetails,
  changeCurrentLocation,
  addUserCurrentLocation,
  updateUserCurrentLocation,
  getCurrentUserLocation,
  updateDrCurrentLocationStatus,
  curData,
  history,
}) => {
  const { is_current_location, id } = curData;

  const location = useGeoLocation();

  React.useEffect(() => {
    getCurrentDoctorDetails();
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    getCurrentUserLocation();
    // eslint-disable-next-line
  }, []);

  const saveLocation = () => {
    if (is_current_location) {
      if (myLocation.id) {
        updateUserCurrentLocation(myLocation.id, location.coordinates, () => {
          updateDrCurrentLocationStatus(id, true);
        });
      } else {
        addUserCurrentLocation(location.coordinates, () => {
          updateDrCurrentLocationStatus(id, true);
        });
      }
    } else {
      updateDrCurrentLocationStatus(id, false);
    }
  };

  return (
    <>
      <Modals
        isOpen={location?.error}
        onBackdropClick={true}
        styles={{
          content: {
            minWidth: "450px",
            maxWidth: "450px",
            minHeight: "250px",
            maxHeight: "250px",
          },
        }}
        title={"Allow Location"}
      >
        <React.Fragment>
          <p className="mx-auto text-center denyAppointmentText">
            {location?.error?.code === 1
              ? "Allow Location access to proceed by clicking on blocked location icon on the address bar and refresh the page."
              : location?.error?.message}
          </p>
        </React.Fragment>
      </Modals>

      <p className="text-dark h5 mb-4">Change Location</p>
      <p className="my-5 mt-n1">
        Your location indicates where you are currently available to provide
        your services. <br />
        Patients can search you by your chosen location.
      </p>

      <div className="addressRadio">
        <RadioButton
          checked={!is_current_location}
          label="Clinic Address"
          onChange={() => changeCurrentLocation()}
        />
        <div className="ml-5">
          <p className="mb-0">{address?.address1}</p>
          <p>
            {address?.state} {address?.zipcode}
          </p>
        </div>
        <p className="my-5"></p>
        <RadioButton
          checked={is_current_location}
          label="Current Location"
          onChange={() => changeCurrentLocation()}
        />
      </div>
      <div className="col-md-4 d-flex justify-content-between align-items-center mt-5">
        <Button
          onClick={() => {
            saveLocation();
          }}
          label="Save "
          className=" mr-3"
        />
        <Button
          type="outline"
          label="Cancel"
          onClick={() => history.push(getDashboardPath("/appointments"))}
          className="btn-block"
        />
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, settings }) => ({
  address: onboarding?.practiceDetails,
  curData: settings?.location?.curDr,
  myLocation: settings?.location?.curLocation,
});

const mapDispatchToProps = dispatch => ({
  getCurrentDoctorDetails: () => dispatch(actions.getCurrentDoctorDetails()),
  changeCurrentLocation: () => dispatch(actions.changeCurrentLocation()),
  getCurrentUserLocation: () => dispatch(actions.getCurrentUserLocation()),
  addUserCurrentLocation: payload =>
    dispatch(actions.addUserCurrentLocation(payload)),
  updateUserCurrentLocation: (userId, payload, cb) =>
    dispatch(actions.updateUserCurrentLocation(userId, payload, cb)),
  updateDrCurrentLocationStatus: (id, status) =>
    dispatch(actions.updateDrCurrentLocationStatus(id, status)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(ChangeLocation);
